import electron from 'electron';

export const getFocusedWindow = () => electron.remote.BrowserWindow.getFocusedWindow();
export const getWebContents = () => getFocusedWindow()?.webContents;
